import { useQuery } from '@tanstack/react-query';
import { fetchWeightUomList } from '@views/screens/common/data-provider/weight-uom-list';

export const useGetWeightUomList = () => {
  return useQuery({
    queryKey: ['weightUomList'],
    queryFn: () => fetchWeightUomList(),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
